import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ParagraphWithEmbeddedObjects } from 'views/common/components';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .AUDark': {
    color: theme.palette.secondary.dark,
  },
  '& .AUOverview': {
    '& .title': {
      color: theme.palette.secondary.dark,
    },
  },
}));
export const StyledParagraphWithEmbeddedObjects = styled(
  ParagraphWithEmbeddedObjects,
)(({ theme }) => ({
  '& .EDText': {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.secondary.main,
  },
  '& .MuiCollapse-root': {
    overflow: 'unset',
  },
}));
export default StyledBox;
